import React from "react";
import ProfitStatCard from "../components/ProfitStatCard";
import ProfitStatusBadge from "../components/ProfitStatusBadge";
import { ProfitCheckIcon } from "../components/ProfitIcons";
import {
  profitBankDetails,
  profitPayoutKpis,
  profitPayoutRows,
  profitPayoutSummary,
} from "../data/profitData";

export default function ProfitPayoutsPage() {
  return (
    <div className="profit-page">
      <div className="profit-page-header">
        <div className="profit-page-title">Payouts</div>
        <div className="profit-page-subtitle">
          Quarterly payout schedule and history
        </div>
      </div>

      <div className="profit-alert profit-alert-success">
        <ProfitCheckIcon />
        <div>
          <strong>Next Payout:</strong> {profitPayoutSummary.nextMessage}
        </div>
      </div>

      <div className="profit-kpi-grid">
        {profitPayoutKpis.map(function renderPayoutKpi(kpi) {
          return (
            <ProfitStatCard
              key={kpi.label}
              stripeClassName={kpi.stripeClassName}
              label={kpi.label}
              value={kpi.value}
            >
              {kpi.detail}
            </ProfitStatCard>
          );
        })}
      </div>

      <div className="profit-card profit-card-table">
        <div className="profit-payout-head">
          <span>Period</span>
          <span>Revenue</span>
          <span>Share%</span>
          <span>Payout Amount</span>
          <span>Due Date</span>
          <span>Status</span>
        </div>
        {profitPayoutRows.map(function renderPayoutRow(row) {
          return (
            <div className="profit-payout-row" key={row.period}>
              <div>
                <strong>{row.period}</strong>
                <div className="profit-muted-text">{row.periodDetail}</div>
              </div>
              <span className="profit-mono">{row.revenue}</span>
              <span>{row.sharePercent}</span>
              <span className="profit-mono profit-table-strong">{row.payoutAmount}</span>
              <span>{row.dueDate}</span>
              <span>
                <ProfitStatusBadge status={row.status} label={row.statusLabel} />
              </span>
            </div>
          );
        })}
      </div>

      <div className="profit-card profit-margin-top">
        <div className="profit-card-header">
          <div className="profit-card-title">Bank Details</div>
        </div>
        {profitBankDetails.map(function renderBankDetail(row) {
          return (
            <div className="profit-settings-row" key={row[0]}>
              <span className="profit-settings-key">{row[0]}</span>
              <span className={"profit-settings-value" + (row[2] ? " " + row[2] : "")}>
                {row[1]}
              </span>
            </div>
          );
        })}
        <div className="profit-settings-actions">
          <button className="profit-button profit-button-outline" type="button">
            Request Bank Update
          </button>
        </div>
      </div>
    </div>
  );
}
